import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { AssetGraphQueryDto } from '@terra/shared-contracts-external-network';
import { terraProxyApiClient } from '../../clients/testerClient';

export const EXTERNAL_NETWORK_GRAPH_KEY = 'external-network-graph';

export function useExternalNetworkGraph({
  surfaceId,
  query,
}: {
  surfaceId: string | null;
  query?: Partial<AssetGraphQueryDto>;
}) {
  const result = useQuery({
    queryKey: [EXTERNAL_NETWORK_GRAPH_KEY, surfaceId, query],
    queryFn: () =>
      terraProxyApiClient.getExternalNetworkGraph(surfaceId ?? '', query),
    enabled: Boolean(surfaceId) && Boolean(query),
    placeholderData: keepPreviousData,
  });

  return {
    graph: result.data,
    isLoading: result.isLoading,
    isFetching: result.isFetching,
    isError: result.isError,
  };
}
